<div class="md-form md-outline mb-0 mt-3">
  <textarea [ngModel]="userId.firstname" (ngModelChange)="onFirstname($event)" id="form-firstname" class="form-control textarea form-{{color}}" rows="1" type="text" mdbInput style="resize:none;"></textarea>
  <label for="form-firstname">{{ 'FIRSTNAME' | translate }}</label>
  <small id="form-firstname-help" class="form-text text-muted d-flex align-items-center">
    <i *ngIf="userId.isValid('firstname')" class="{{color}}-text fas fa-check-circle pr-1"></i>
    <i *ngIf="!userId.isValid('firstname')" class="text-warning fas fa-times-circle pr-1"></i>
    <span class="mr-auto">{{userId.firstname.length}}/{{userId.requirement('firstname').maxLength}} ({{ 'MINIMUM' | translate }}: {{userId.requirement('firstname').minLength}})</span>
  </small>
</div>